module.exports = __webpack_public_path__ + "img/main_gjw.336c0a40.jpg";